import { render, staticRenderFns } from "./CommentMenu.vue?vue&type=template&id=3ad24a12&scoped=true&"
import script from "./CommentMenu.vue?vue&type=script&lang=js&"
export * from "./CommentMenu.vue?vue&type=script&lang=js&"
import style0 from "./CommentMenu.vue?vue&type=style&index=0&id=3ad24a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad24a12",
  null
  
)

export default component.exports